import { Rule } from '../../Rules'

const changesRules: Array<Rule> = [
  {
    details: 'The time remaining on all Live auctions were rerolled by the random generator.',
    reason:
      'When restoring the state, we run the same transactions in the same order they were to get to that state.  Some of these transactions use the current time and a random auction length.',
    summary: 'Auction timers were reset.',
  },
  {
    details: 'The Dutch Auctions were treated as if auction had finished at the time of the fork.  This resets their price.',
    reason:
      'We did this to minimize the risk of the changes and also to prevent a rush for the under priced geotokens.  The fix of the Dutch Auction Price calculation also can then be honored.',
    summary: 'Dutch Auctions were reset.',
  },
]

export default changesRules
